import { useEffect, useState } from "react";

export const agoText = (iso) => {
  if (!iso) return "—";
  const sec = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (sec < 60) return `${sec} sn önce`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} dk ${sec % 60} sn önce`;
  return `${Math.floor(min / 60)} sa ${min % 60} dk önce`;
};

export function useAgo(iso) {
  const [txt, setTxt] = useState(() => agoText(iso));
  useEffect(() => {
    setTxt(agoText(iso));
    const i = setInterval(() => setTxt(agoText(iso)), 1000);
    return () => clearInterval(i);
  }, [iso]);
  return txt;
}
